import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";
import { UrlBase } from "../../url/Urls";
import {
  getInvoicesRequestType,
  InvoiceContent,
  InvoiceSearchParams,
  getInvoicesWithActivitiesRequestType,
  InvoiceWithActivitiesSearchParams,
} from "./InvoicesType";

/**
 * Obtiene el listado paginado de facturas.
 */
export const getRequestInvoices = async ({
  filter = "",
  page,
  size = UrlBase.registration_x_page,
  startDate,
  endDate,
}: InvoiceSearchParams): Promise<getInvoicesRequestType | null> => {
  let responseData: getInvoicesRequestType | null = null;

  const params = new URLSearchParams();
  if (filter) params.append("filter", filter);
  params.append("page", String(page));
  params.append("size", String(size));
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  await privateFetch
    .get(URL.REQUEST_INVOICES, {
      params,
      headers: { ...CONSTANT.HEADER_TYPE },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });

  return responseData;
};

/**
 * Obtiene el detalle completo de una factura por su id.
 */
export const getInvoiceById = async (
  id: number
): Promise<InvoiceContent | null> => {
  let responseData: InvoiceContent | null = null;

  await privateFetch
    .get(URL.REQUEST_INVOICE_BY_ID(id), {
      headers: { ...CONSTANT.HEADER_TYPE },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });

  return responseData;
};

/**
 * Obtiene el listado paginado de facturas con sus actividades de inventario.
 * Exclusivo para ManagementInvoices.
 */
export const getInvoicesWithActivities = async ({
  filter = "",
  page,
  size = UrlBase.registration_x_page,
}: InvoiceWithActivitiesSearchParams): Promise<getInvoicesWithActivitiesRequestType | null> => {
  let responseData: getInvoicesWithActivitiesRequestType | null = null;

  await privateFetch
    .post(
      URL.REQUEST_INVOICES_WITH_ACTIVITIES,
      { filter, page, size },
      { headers: { ...CONSTANT.HEADER_TYPE } }
    )
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });

  return responseData;
};
